var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg137(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 84,
    viewBox: "0 0 92 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4797 82.0633C55.8024 84.2042 60.3521 81.5664 60.9378 77.6696C61.5712 73.4498 57.2446 70.609 53.6112 71.0439C49.5833 71.5284 46.9977 76.1581 48.3722 80.1004C49.7467 84.0427 54.6351 85.1815 57.7027 82.6596C58.5274 81.9846 57.3641 80.792 56.5514 81.4628C54.2406 83.3595 50.5315 82.1006 49.7785 79.1314C49.0256 76.1622 51.0733 72.8949 54.0853 72.6962C56.4398 72.5388 59.3561 74.158 59.3601 76.9035C59.3601 79.9099 55.7745 82.1917 53.2924 80.6015C52.396 80.0259 51.5793 81.4918 52.4717 82.0633H52.4797Z",
    fill: "#10100E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85807 30.4674C10.2031 33.2671 16.1528 29.8176 16.9186 24.7218C17.747 19.2036 12.0891 15.4888 7.33767 16.0574C2.0705 16.6909 -1.3107 22.7452 0.4867 27.9006C2.2841 33.0559 8.67661 34.5451 12.6882 31.2472C13.7666 30.3645 12.2454 28.8049 11.1826 29.6822C8.16083 32.1624 3.31045 30.5161 2.32578 26.6334C1.34112 22.7506 4.01899 18.478 7.95765 18.218C11.0367 18.0123 14.8503 20.1296 14.8555 23.72C14.8555 27.6515 10.1666 30.6353 6.92088 28.5558C5.74866 27.8031 4.68064 29.7201 5.84765 30.4674H5.85807Z",
    fill: "#10100E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2702 20.4246C82.4044 24.3771 90.8039 19.5071 91.8851 12.3131C93.0546 4.52277 85.0669 -0.721762 78.3591 0.0809727C70.9231 0.975449 66.1496 9.52266 68.6871 16.8008C71.2246 24.0789 80.2493 26.1813 85.9128 21.5254C87.4353 20.2793 85.2876 18.0775 83.7871 19.316C79.5212 22.8175 72.6736 20.4934 71.2835 15.0118C69.8933 9.5303 73.6739 3.49833 79.2343 3.13136C83.5812 2.84085 88.9651 5.83008 88.9725 10.8988C88.9725 16.4491 82.3529 20.6616 77.7707 17.7258C76.1158 16.6632 74.608 19.3695 76.2555 20.4246H76.2702Z",
    fill: "#10100E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9539 72.3864C50.9539 72.3864 31.6438 43.5993 12.96 29.4307",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg137);
export default __webpack_public_path__ + "static/media/137.7ba92226a7b84479b1653a2cfdecffcc.svg";
export { ForwardRef as ReactComponent };